import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'rank-type',
  templateUrl: './rank-type.component.html',
  styleUrls: ['./rank-type.component.css']
})
export class RankTypeComponent implements OnInit{

  //Self explanatory

  @Input() question_index: number;
  @Input() question_name : string;
  @Input() question_name_second : string;
  @Input() is_mandt : boolean;
  @Input() question_options : [string];
  @Input() question_options_second : string;
  @Input() is_Qn_Dep : boolean;
  @Input() indexOfRepeater : number;
  @Input() userRes : string[];
  @Input() question_number : number;
  @Output() user_Resp = new EventEmitter<string[]>();

  options : any;
  numOfChild : number;  
  result: string[];

  ngOnInit(){
    this.options = [];
    this.result = [];
    this.options = this.question_options;
    this.numOfChild =  this.question_options.length;
    for(let i in this.options)
    {
      this.result.push('');
    }
  }
  // selectedRankItem =function(block , selected){
  //     // console.log("selected " + this.options[selected]  + " at block " + (block));
  //     this.result[block] = this.options[selected];  
  // }


  itemUp = function (index) {
    if (index <= 0 || index >= this.options.length)
      return;
    var temp = this.options[index];
    this.options[index] = this.options[index - 1];
    this.options[index - 1] = temp;
    this.response = this.options;
    this.user_Resp.emit([this.indexOfRepeater.toString(),this.question_number.toString(),this.response]);

  };

  itemDown = function (index) {
    if (index < 0 || index >= (this.options.length - 1))
      return;
    var temp = this.options[index];
    this.options[index] = this.options[index + 1];
    this.options[index + 1] = temp;
    this.response = this.options;
    this.user_Resp.emit([this.indexOfRepeater.toString(),this.question_number.toString(),this.response]);
  };

}


// WEBPACK FOOTER //
// ./src/app/questions-type/rank-type/rank-type.component.ts